import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../app/stores/store';
import AppUserRecord from './AppUserRecord';
import React, { useEffect, useState } from 'react';
import SkeltonAnimation from '../../../app/layout/SkeltonAnimation';
import { withNavbar } from '../../../app/layout/HOC';

const AppUser=()=> {
  const [value, setValue] = useState('1');

  const { adminStore, appDataStore, modalStore } = useStore();
  const { loadAdminAppUsers, adminAppUsers, adminAppUsersLoading } = adminStore;
  const { loadAdminAppData, adminAppData, adminAppDataLoading } = appDataStore;

  useEffect(() => {
    if (adminAppUsers && adminAppUsers.length < 1) {
      loadAdminAppUsers();
    }
  }, [loadAdminAppUsers, adminAppUsers])

  useEffect(() => {
    if (!adminAppData) {
      loadAdminAppData();
    }
  }, [adminAppData, loadAdminAppData])

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  if (adminAppDataLoading) return <SkeltonAnimation iteration={10} />
  return (
    <Box sx={{ width: '100%', typography: 'body1', mt:20 }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange} aria-label="Admin users tab">
            <Tab label="All" value="1" />
            <Tab label="Active" value="2" />
            <Tab label="Requests" value="3" />
            <Tab label="Blocked" value="4" />
          </TabList>
        </Box>
        <TabPanel value="1">
          <AppUserRecord loading={adminAppUsersLoading}
            users={adminAppUsers} modalStore={modalStore}
          />
        </TabPanel>
        <TabPanel value="2">
          <AppUserRecord loading={adminAppUsersLoading}
            users={adminAppUsers.filter(x => x.approved && x.emailConfirmed)}
            modalStore={modalStore}
          />
        </TabPanel>
        <TabPanel value="3"><AppUserRecord loading={adminAppUsersLoading}
          users={adminAppUsers.filter(x => (!x.approved && !x.emailConfirmed) || (x.approved && !x.emailConfirmed))}
           modalStore={modalStore}         
        />
        </TabPanel>
        <TabPanel value="4">
          <AppUserRecord loading={adminAppUsersLoading}
            users={adminAppUsers.filter(x => x.blocked)}
            modalStore={modalStore}
          />
        </TabPanel>
      </TabContext>
    </Box>
  );
}

const AppUserPage = withNavbar(observer(AppUser));

export default AppUserPage;